<template>
    <section :class="this.active ? 'current' : ''">
        <div @click="openCloseSection()" class="questionaire_sections_title" :class="(show || this.active || completed > 0  ? (chapterIntro && title === sectionTitle ? 'active current_active' : 'active') : 'disabled')">
            <div>{{ $t('overview:'+title+':pageTitle') }}</div>
            <div class="questionaire_sections_count">
                <span>{{ (completed > 0) ? Object.keys(chapter.step).length : this.currentStep }}/{{ Object.keys(chapter.step).length }}</span>
                <SvgIcon :type="(show ? 'icon_arrow_up_black' : (completed > 0 ? 'icon_arrow_down_red' : 'icon_arrow_down_black'))"/>
            </div>
        </div>
        <div class="questionaire_sections_content" :class="show ? '' : 'hidden'">
            <div v-for="(result, index) in chapter.step" :key="index"
                :class="((index <= currentStep || completed > 0) ? ((parseInt(result.step) === activeQuestionStep && title === sectionTitle) ? 'completed current_active' : 'completed')
                    : ((index === activeItem) || (index == currentStep + 1 && index > 1 && completed <=0) || (activeQuestion && index == 1)) ? ((parseInt(result.step) === activeQuestionStep && title === sectionTitle) ? 'active current_active' : 'active') : 'disabled')"
                    >
                <SvgIcon v-if="(index <= currentStep || completed > 0)" class="check_icon" type="tick-black-thick"/>
                <span> {{ $t('checklist:tasks:question') }} {{ result.step }}</span>
            </div>
        </div>
    </section>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'
import current from '@/mixins/current'

export default {
    name: 'QuestionStep',
    props: [
        'chapter',
        'title',
        'step',
        'completed',
        'active',
        'activeQuestion',
        'stepData'
    ],
    mixins: [current],
    components: {
        SvgIcon
    },
    data: function() {
        return {
            activeItem: '',
            show: this.active
        }
    },
    watch: {
        active: function() {
            if (this.active) {
                this.show = true
            } else {
                this.show = false
            }
        }
    },
    computed: {
        currentStep: function() {
            return this.$store.getters['app/currentStep']
        },
        section: function() {
            return this.$store.getters['app/section']
        },
        sectionTitle: function() {
            return this.$store.getters['app/sectionTitle']
        },
        chapterIntro: function() {
            return this.$store.getters['app/chapterIntro']
        },
        activeQuestionStep: function() {
            return this.$store.getters['app/activeQuestionStep']
        }
    },
    methods: {
        openCloseSection() {
            this.show = !this.show
        },
        checkQuestion(value, title, index) {
            this.setChapterIntro(false)
            this.activeItem = index
            this.$emit('handleQuestionSelected', value, title)
        }
    }
}
</script>
